import React from "react";
import { Alert, Button } from "reactstrap";

export enum DebugTypes {
    Danger = "danger",
    Warning = "warning",
    Info = "info",
}

export type DebugNotificationProps = {
    isDebug: boolean;
    message: string;
    url?: string;
    correlationId?: string;
    type: DebugTypes;
};

const DebugNotification = ({
    message,
    url,
    type,
    correlationId,
    isDebug,
}: DebugNotificationProps) => {
    const copyUrl = () => {
        url && navigator.clipboard.writeText(url);
    };

    const copyCorrelationId = () => {
        correlationId && navigator.clipboard.writeText(correlationId);
    };

    return isDebug ? (
        <Alert color={type}>
            {message}
            <Button color="link" onClick={copyCorrelationId}>
                <i className="las la-copy pr-2"></i>
                {"Copy C-ID"}
            </Button>
            {url && (
                <Button color="link" onClick={copyUrl}>
                    <i className="las la-copy pr-2"></i>
                    {"Copy Url"}
                </Button>
            )}
        </Alert>
    ) : (
        <div
            data-ssr-error
            dangerouslySetInnerHTML={{ __html: `<!-- ${correlationId} -->` }}
        ></div>
    );
};

export { DebugNotification };
